export default "__VITE_PUBLIC_ASSET__5cc74284__"